'use client'

import { Box, ChakraProvider } from '@chakra-ui/react'
import theme from '@web/components/theme'

export default function NotFound() {
  const contactSupport = () => {
    const user = 'support'
    const domain = 'giveeasy'
    const extension = 'org'
    const email = `${user}@${domain}.${extension}`
    window.location.href = `mailto:${email}`
  }

  return (
    <ChakraProvider value={theme}>
    <Box
      css={{
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        background: 'linear-gradient(135deg, #00bcd4 0%, #2196f3 50%, #0d7377 100%)',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#333',
        position: 'relative',
        '&::before': {
          content: "''",
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='20' cy='20' r='2' fill='rgba(255,255,255,0.1)'/><circle cx='80' cy='40' r='1.5' fill='rgba(255,255,255,0.08)'/><circle cx='40' cy='70' r='1' fill='rgba(255,255,255,0.06)'/><circle cx='90' cy='80' r='2.5' fill='rgba(255,255,255,0.04)'/><circle cx='10' cy='60' r='1.8' fill='rgba(255,255,255,0.07)'/></svg>") repeat`,
          pointerEvents: 'none',
        },
        '& .container': {
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderRadius: '20px',
          padding: '60px 40px',
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
          maxWidth: '600px',
          width: '90%',
          position: 'relative',
          zIndex: 1,
        },
        '& .icon-container': {
          marginBottom: '30px',
        },
        '& .icon': {
          width: '80px',
          height: '80px',
          background: 'linear-gradient(135deg, #00bcd4, #2196f3)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto',
          color: 'white',
          fontSize: '36px',
          boxShadow: '0 10px 30px rgba(0, 188, 212, 0.3)',
        },
        '& h1': {
          fontSize: '2.5rem',
          color: '#2d3748',
          marginBottom: '20px',
          fontWeight: 600,
          letterSpacing: '-0.02em',
        },
        '& .main-message': {
          fontSize: '1.1rem',
          color: '#4a5568',
          marginBottom: '30px',
          lineHeight: 1.6,
        },
        '& .secondary-message': {
          fontSize: '0.95rem',
          color: '#718096',
          lineHeight: 1.5,
          marginBottom: '30px',
          padding: '20px',
          background: 'rgba(0, 188, 212, 0.05)',
          borderRadius: '10px',
          borderLeft: '4px solid #00bcd4',
        },
        '& .contact-link': {
          display: 'inline-block',
          background: 'linear-gradient(135deg, #00bcd4, #2196f3)',
          color: 'white',
          textDecoration: 'none',
          padding: '12px 30px',
          borderRadius: '50px',
          fontWeight: 600,
          transition: 'all 0.3s ease',
          boxShadow: '0 5px 15px rgba(0, 188, 212, 0.3)',
          cursor: 'pointer',
        },
        '& .contact-link:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 25px rgba(0, 188, 212, 0.4)',
        },
        '& .footer': {
          position: 'absolute',
          bottom: '30px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1,
        },
        '& .logo-link': {
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          opacity: 0.7,
          transition: 'opacity 0.3s ease',
        },
        '& .company-name': {
          color: 'white',
          fontSize: '0.9rem',
          fontWeight: 500,
        },
        '@media (max-width: 768px)': {
          '& .container': {
            padding: '40px 30px',
            margin: '20px',
          },
          '& h1': {
            fontSize: '2rem',
          },
          '& .main-message': {
            fontSize: '1rem',
          },
          '& .secondary-message': {
            fontSize: '0.9rem',
            padding: '15px',
          },
        },
      }}
    >
      <title>404 - Page Not Found</title>
      <div className="container">
        <div className="icon-container">
          <div className="icon">📄</div>
        </div>

        <h1>Page Not Found</h1>

        <p className="main-message">
          The fundraising page you&rsquo;re looking for is not available. <br />
          We apologize for any inconvenience this may cause.
        </p>

        <div className="secondary-message">
          If you&rsquo;re a GiveEasy customer and believe this is an error, or if you need assistance accessing your
          fundraising content, please don&rsquo;t hesitate to reach out to our support team.
        </div>

        <a href="#" onClick={() => contactSupport()} className="contact-link">
          Contact Support
        </a>
      </div>

      <div className="footer">
        <a
          href="https://www.giveeasy.org?utm_source=donation-platform&utm_medium=footer&utm_campaign=404-landing-page"
          className="logo-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="company-name">GiveEasy</span>
        </a>
      </div>
    </Box>
    </ChakraProvider>
  )
}
